import { Chess } from "chess.js";
import { MoveWithComment, PlayerColor } from "./models";
import axios from "axios";

// Old version with calling backend
export const fetchLichessLinkOld = async (game: Chess, playerColor: PlayerColor, attemptId?: number) => {
    if (playerColor === "w") {
        game.header("White", "You");
        game.header("Black", "Engine");
    } else {
        game.header("White", "Engine");
        game.header("Black", "You");
    }

    game.header("Event", "From https://www.openingtrainer.com");
    game.header("ID", attemptId?.toString() || "");
    game.header("Annotator", "https://www.openingtrainer.com");

    const response = await axios.post(
        `${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/lichess-link`,
        {
            pgn: game.pgn(),
        },
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );
    const gameLink = response.data.gameLink;
    const boardOrientationString = playerColor === "b" ? "/black" : "";
    const gameLinkWithOrientation = gameLink + boardOrientationString;

    return gameLinkWithOrientation;
};

const isIos = () =>
    ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document);

export const fetchLichessLink = async (
    game: Chess,
    playerColor: PlayerColor,
    redoStack?: MoveWithComment[],
    isMobile?: boolean
) => {
    if (isMobile && isIos()) {
        return fetchLichessLinkOld(game, playerColor);
    }

    const newGame = new Chess();
    newGame.loadPgn(game.pgn());
    const moveNumber = newGame.history().length;

    if (redoStack) {
        redoStack
            .slice()
            .reverse()
            .forEach((move) => {
                newGame.move(move.san);
            });
    }
    const linkSuffix = newGame.pgn();
    return `https://lichess.org/analysis/pgn/${encodeURIComponent(linkSuffix)}?color=${
        playerColor === "w" ? "white" : "black"
    }#${moveNumber}`;
};
